/**
 * @file: PlatformType.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum PlatformType {
  Android = 'android',
  IOs = 'ios',
  Web = 'web',
}

export const PlatformTypeValueSet = new Set([
  PlatformType.Android,
  PlatformType.IOs,
  PlatformType.Web,
]);
